module.exports = __webpack_public_path__ + "img/outgoing-gray.72944706.svg";